// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon___2JbU","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1MAHU"};